module.exports = __webpack_public_path__ + "static/media/undraw_secure_login_pdn4.3fc53997.svg";